import { languages } from "./schema";

export const availableLanguages = [
  { value: "en", label: "English" },
  { value: "it", label: "Italian" },
  { value: "tr", label: "Turkish" },
  { value: "es", label: "Espanol" },
  { value: "de", label: "German" },
  { value: "fr", label: "French" },
  { value: "pt", label: "Portuguese" }
] as const satisfies {
  value: (typeof languages)[number];
  label: string;
}[];
